// Shared compensation / budget helpers used across CandidateDetail, JobView, Kanban, CandidatesList.

const SYMBOLS = {
    INR: "₹", USD: "$", EUR: "€", GBP: "£",
    AED: "AED ", SGD: "S$", AUD: "A$", CAD: "C$",
};

export function formatCompCurrency(amount, currency = "INR", period) {
    if (amount === null || amount === undefined || amount === "" || Number.isNaN(Number(amount))) {
        return "—";
    }
    const sym = SYMBOLS[currency] || `${currency} `;
    const n = Number(amount);
    let pretty;
    // Pretty-print large numbers with locale separators; for INR show in lakh/crore for >= 1L
    if (currency === "INR" && Math.abs(n) >= 100000) {
        if (Math.abs(n) >= 10000000) pretty = `${(n / 10000000).toFixed(2)} Cr`;
        else pretty = `${(n / 100000).toFixed(2)} L`;
    } else if (Math.abs(n) >= 1000) {
        pretty = n.toLocaleString("en-US", { maximumFractionDigits: 0 });
    } else if (Number.isInteger(n)) {
        pretty = String(n);
    } else {
        // Small decimal values (e.g. a monthly figure derived from a lakh unit)
        // — don't bleed 16 digits of float noise into the UI.
        pretty = n.toLocaleString("en-US", { maximumFractionDigits: 2 });
    }
    const periodTag = period === "monthly" ? "/mo" : "";
    return `${sym}${pretty}${periodTag}`;
}

export function budgetBadgeClass(status) {
    switch (status) {
        case "at":
        case "in":
            return "bg-emerald-50 text-emerald-700 border-emerald-300";
        case "under":
            return "bg-blue-50 text-ikb border-ikb/40";
        case "over":
            return "bg-rose-50 text-rose-700 border-rose-300";
        case "unknown":
            return "bg-amber-50 text-amber-700 border-amber-300";
        default:
            return "bg-secondary text-foreground/70 border-border";
    }
}

export function budgetLabel(status) {
    switch (status) {
        case "at": return "In budget";
        case "under": return "Under budget";
        case "over": return "Over budget";
        case "unknown": return "Currency mismatch";
        default: return "No data";
    }
}

export function shortBudgetTag(status) {
    switch (status) {
        case "at": return "₹ In";
        case "under": return "₹ Under";
        case "over": return "₹ Over";
        case "unknown": return "₹ ?";
        default: return null;
    }
}
